export let Components = /*#__PURE__*/function (Components) {
  Components["FORM"] = "form";
  Components["NO_AVAILABILITY_FOR_DATE"] = "no availability for date empty state";
  Components["NO_AVAILABILITY_AT_ALL"] = "no availability at all empty state";
  Components["SLOT"] = "slot";
  Components["DATE"] = "date";
  Components["PAGINATION"] = "pagination";
  Components["SHOW_MORE"] = "show more";
  return Components;
}({});
export let Actions = /*#__PURE__*/function (Actions) {
  Actions["LOAD"] = "load";
  Actions["CLICK"] = "click";
  return Actions;
}({});
//# sourceMappingURL=bi-types.js.map